<header
  #unitHeader
  data-test="mono-common-unit-player-header"
  class="unit-player-header"
  [ngClass]="[
  progressBar ? 'unit-player-header--with-progress-bar' : '',
    hideTheHeader ? 'unit-player-header--small-mobile-slide-up' : '',
    signInHeader ? 'sign-in-header' : ''
  ]"
  aria-describedby="ariaHeaderId"
>
  <div
    class="flex-container unit-player-header__content"
    [ngClass]="signInHeader ? 'sign-in-header__content' : ''"
  >
    <button
      class="button clear close-button"
      type="button"
      (click)="closeButtonClicked()"
      #closeButton
    >
      <svg class="icon icon--exit">
        <use xlink:href="#icon-exit" href="#icon-exit"></use>
      </svg>
      <span
        class="show-for-sr"
        >Exit learning</span
      >
    </button>
    <h1 id="ariaHeaderId" class="align-self-middle">{{ headerText }}</h1>
  </div>
</header>
